import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import az from './locales/az.json';
import en from './locales/en.json';
import tr from './locales/tr.json';
import ru from './locales/ru.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      az: { translation: az },
      en: { translation: en },
      tr: { translation: tr },
      ru: { translation: ru },
    },
    fallbackLng: 'az',
    supportedLngs: ['az', 'en', 'tr', 'ru'],
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'karma_lang',
    },
  });

export default i18n;
